export default __webpack_public_path__ + "static/media/Icons_Add Icon.3dd77351.svg";